import React from "react";
import { useField, useFormikContext } from "formik";
import { useEffect, useState } from "react";
import { SelectOption } from "../../../dropdown/Dropdown";
import { parseListDate } from "helpers/parseListDate";
import { formatPropertyName } from "./SearchListRenderer";

type EditMultiSelectReadOnlyProps = {
  name: string;
  dataSource: string | null;
  showUseDefaultValues?: boolean;
  showUseRoleValues?: boolean;
};

export const EditMultiSelectReadOnly: React.FC<EditMultiSelectReadOnlyProps> = ({
  name,
  dataSource,
}) => {
  const [field] = useField<any>(name);
  const formik = useFormikContext<any>();
  const [dataSourceData, setDataSourceData] = useState<SelectOption[] | null>(
    null
  );
  const [displayData, setDisplayData] = useState<string[] | null>(null);

  useEffect(() => {
    if (
      dataSource &&
      formik.values &&
      formik.values.hasOwnProperty(dataSource)
    ) {
      setDataSourceData(formik.values[dataSource]);
    }
  }, []);

  const generateString = (value: number) => {
    if (dataSourceData) {
      const filteredDataSourceData = dataSourceData.filter(
        item => item.value === value
      );
      if (filteredDataSourceData && filteredDataSourceData.length === 1) {
        return filteredDataSourceData[0].label;
      }
    }
  };

  useEffect(() => {
    if (field.value && Array.isArray(field.value) && field.value.length > 0) {
      let tempStrings: string[] = [];

      field.value.map((item, i) => {
        if (item.label && typeof item.label === "string") {
          tempStrings = [...tempStrings, item.label];
        } else if (typeof item === "number") {
          let string = generateString(item);
          if (string) {
            tempStrings = [...tempStrings, string];
          }
        }
      });

      if (tempStrings.length > 0) {
        setDisplayData(tempStrings);
      } else {
        setDisplayData(null);
      }
    } else {
      setDisplayData(null);
    }
  }, []);

  return (
    <div
      className="EditBox ViewOnly SearchListRenderer Multi"
      style={{ height: "fit-content" }}
    >
      {field.value && Array.isArray(field.value) && field.value.length > 0 ? (
        field.value.map((item, i) => {
          const moreDetails = Object.keys(item).length > 2;
          return (
            <div
              className="ListContainer"
              style={
                i === field.value.length - 1 ? { marginBottom: "0px" } : {}
              }
            >
              <div className="Item">{`${item.label}${
                moreDetails ? " -" : ""
              }`}</div>
              {moreDetails && (
                <div className="MoreDetails">
                  {Object.entries(item).map(([key, value]) => {
                    if (key === "addDate") {
                      value = parseListDate(String(value), false);
                    }
                    return key === "label" || key === "value" ? null : (
                      <div className="OptionInfo">
                        <div className="OptionKey">
                          {formatPropertyName(key)}
                        </div>
                        <div className="OptionValue">{value ?? " - "}</div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })
      ) : (
        <div className="NoItemsData">{`No data`}</div>
      )}
    </div>
  );
};
